export const FILTER_TYPES = {
  STAGE: "stage",
  ASSIGNED_TO: "assignedTo",
  CREATED_DATE: "createdDate",
  UPDATED_DATE: "updatedDate",
  STAGE_UPDATED: "stageUpdated",
  CUSTOM: "custom",
};

export const FILTER_TYPE_OPTIONS = [
  { value: FILTER_TYPES.STAGE, label: "Stage" },
  { value: FILTER_TYPES.ASSIGNED_TO, label: "Assigned To" },
  { value: FILTER_TYPES.CREATED_DATE, label: "Created Date" },
  { value: FILTER_TYPES.UPDATED_DATE, label: "Updated Date" },
  { value: FILTER_TYPES.STAGE_UPDATED, label: "Stage Updated Date" },
  { value: FILTER_TYPES.CUSTOM, label: "Lead field" },
];

export const FILTER_TYPE_LABELS = FILTER_TYPE_OPTIONS.reduce((labels, option) => {
  labels[option.value] = option.label;
  return labels;
}, {});

export const DATE_PRESETS = {
  TODAY: "today",
  YESTERDAY: "yesterday",
  LAST_7_DAYS: "last_7_days",
  LAST_30_DAYS: "last_30_days",
  THIS_MONTH: "this_month",
  CUSTOM_RANGE: "custom_range",
};

export const DATE_PRESET_OPTIONS = [
  { value: DATE_PRESETS.TODAY, label: "Today" },
  { value: DATE_PRESETS.YESTERDAY, label: "Yesterday" },
  { value: DATE_PRESETS.LAST_7_DAYS, label: "Last 7 Days" },
  { value: DATE_PRESETS.LAST_30_DAYS, label: "Last 30 Days" },
  { value: DATE_PRESETS.THIS_MONTH, label: "This Month" },
  { value: DATE_PRESETS.CUSTOM_RANGE, label: "Custom Range" },
];

export const DATE_PRESET_LABELS = DATE_PRESET_OPTIONS.reduce((labels, option) => {
  labels[option.value] = option.label;
  return labels;
}, {});

export const SORT_FIELDS = {
  ID: "id",
  LEAD_NAME: "name",
  CREATED_AT: "created_at",
  UPDATED_AT: "updated_at",
  STAGE_UPDATED_AT: "stage_updated_at",
};

export const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
};

export const SORT_OPTIONS = [
  { field: SORT_FIELDS.CREATED_AT, direction: SORT_DIRECTIONS.DESC, label: "Created Date - Newest First" },
  { field: SORT_FIELDS.CREATED_AT, direction: SORT_DIRECTIONS.ASC, label: "Created Date - Oldest First" },
  { field: SORT_FIELDS.UPDATED_AT, direction: SORT_DIRECTIONS.DESC, label: "Updated Date - Newest First" },
  { field: SORT_FIELDS.UPDATED_AT, direction: SORT_DIRECTIONS.ASC, label: "Updated Date - Oldest First" },
  { field: SORT_FIELDS.LEAD_NAME, direction: SORT_DIRECTIONS.ASC, label: "Lead Name - A-Z" },
  { field: SORT_FIELDS.LEAD_NAME, direction: SORT_DIRECTIONS.DESC, label: "Lead Name - Z-A" },
  { field: SORT_FIELDS.STAGE_UPDATED_AT, direction: SORT_DIRECTIONS.DESC, label: "Stage Updated - Newest First" },
  { field: SORT_FIELDS.STAGE_UPDATED_AT, direction: SORT_DIRECTIONS.ASC, label: "Stage Updated - Oldest First" },
];

export const DEFAULT_SORT = {
  field: SORT_FIELDS.CREATED_AT,
  direction: SORT_DIRECTIONS.DESC,
};

export const DEFAULT_FILTERS = {
  stageIds: [],
  nodeIds: [],
  assignedTo: [],
  leadIds: [],
  queueKey: null,
  queueLabel: null,
  createdDate: null,
  updatedDate: null,
  stageUpdated: null,
  customFields: {},
};
